import { BUTTON_CLICKED } from '../../actions/button-clicked';
import {
  BUTTON_CREATE_POST,
  BUTTON_FOLLOW_POST,
  BUTTON_SHARE_POST_MODAL,
  BUTTON_SHARE_POST,
  BUTTON_EDIT_POST,
  BUTTON_SHARE_COMMENT_MODAL,
} from '../bi-buttons';
import { getCurrentUserRole } from '@wix/communities-blog-client-common';
import { categoryIds } from '../event-helpers';

const handler = (action, state) => {
  switch (action.payload.action) {
    case BUTTON_FOLLOW_POST: {
      const { post, flag } = action.payload;

      return {
        evid: 229,
        is_followed: flag,
        category_ids: categoryIds(post), // todo, [bug] categories are not set in state in members area posts and drafts page
        post_id: post._id,
      };
    }
    case BUTTON_EDIT_POST: {
      const { post } = action.payload;

      return {
        evid: 237,
        category_ids: categoryIds(post), // todo, [bug] categories are not set in state in members area posts and drafts page
        post_id: post._id,
      };
    }
    case BUTTON_CREATE_POST: {
      const { biPage } = action.payload;

      return {
        evid: 208,
        ...(biPage && { page_name: biPage }),
        eventMeta: {
          description: 'write new post click',
        },
      };
    }
    case BUTTON_SHARE_POST_MODAL:
      return {
        evid: 213,
        eventMeta: {
          description: 'open share modal',
        },
        post_id: action.payload.postId,
        role: getCurrentUserRole(state),
      };
    case BUTTON_SHARE_POST:
      return {
        evid: 214,
        eventMeta: {
          description: 'share post',
        },
        shareType: action.payload.shareType,
        post_id: action.payload.postId,
        role: getCurrentUserRole(state),
      };
    case BUTTON_SHARE_COMMENT_MODAL:
      const { post, commentId } = action.payload;

      return {
        evid: 235,
        post_id: post._id,
        category_ids: categoryIds(post),
        comments_id: commentId,
      };
    default:
      return;
  }
};

export const uouButtonClickedEvent = { [BUTTON_CLICKED]: handler };
